<template>

    <b-container flex>
        <div style="padding-top: 20px; padding-bottom: 10px"><span
            style="font-weight: bold; font-size:large; padding-top: 20px; padding-bottom: 10px">Production Data (per calendar year)</span>
        </div>
        <b-row style="margin-bottom: 10px ">
            <b-col sm="9">Crush to Bottle Brand Wine Produced on Site (Gal)</b-col>
            <b-col sm="3">
                <b-form-input v-model="brandWineProduced" value="620" @change="productionChanged"
                              type="number" step="0.01" min="0.00" max="10000000.00" :readonly=isViewer></b-form-input>
            </b-col>
        </b-row>
        <b-row align-h="start" style="padding-bottom: 10px">
          <b-col cols="1"></b-col>
          <b-col cols="10" style="color: darkgreen; font-style: italic">*Wine produced and bottled onsite
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px ">
          <b-col sm="9">Crush to Bottle Custom Crush Produced on Site (Gal)</b-col>
            <b-col sm="3">
              <b-form-input v-model="customCrushWineProduced" value="620" @change="productionChanged"
                            :readonly=isViewer></b-form-input>
            </b-col>
        </b-row>
      <b-row align-h="start" style="padding-bottom: 10px">
        <b-col cols="1"></b-col>
        <b-col cols="10" style="color: darkgreen; font-style: italic">*Custom crush produced and bottled onsite
        </b-col>
      </b-row>
        <b-row style="margin-bottom: 10px ">
          <b-col sm="9">Crush to Wine - Bottled off site (Gal)</b-col>
            <b-col sm="3">
              <b-form-input v-model="bulkWineShippedOffsite" value="620" @change="productionChanged"
                            :readonly=isViewer></b-form-input>
            </b-col>
        </b-row>
      <b-row align-h="start" style="padding-bottom: 10px">
        <b-col cols="1"></b-col>
        <b-col cols="10" style="color: darkgreen; font-style: italic">*80% of this gallonage used in metric
          calculation
        </b-col>
      </b-row>

      <b-row style="margin-bottom: 10px ">
        <b-col sm="9">Bulk Wine In (Bottling only or Bulked Out) (Gal)</b-col>
        <b-col sm="3">
          <b-form-input v-model="bulkWineIn" value="620" @change="productionChanged"
                        :readonly=isViewer></b-form-input>
        </b-col>
      </b-row>
      <b-row align-h="start" style="padding-bottom: 10px">
        <b-col cols="1"></b-col>
        <b-col cols="10" style="color: darkgreen; font-style: italic">*20% of this gallonage used in metric calculation
        </b-col>
      </b-row>


      <b-row style="margin-bottom: 10px ">
        <b-col sm="9">Wine storage only-barrels (Gal)</b-col>
        <b-col sm="3">
          <b-form-input v-model="wineStorageBarrels" value="620" @change="productionChanged"
                        type="number" step="1" min="0.00" max="10000000.00" :readonly=isViewer></b-form-input>
        </b-col>
      </b-row>
      <b-row align-h="start" style="padding-bottom: 10px">
        <b-col cols="1"></b-col>
        <b-col cols="10" style="color: darkgreen; font-style: italic">*15% of this gallonage used in metric calculation
        </b-col>
      </b-row>

      <b-row style="margin-bottom: 10px ">
        <b-col sm="9">Total Gallons of Wine</b-col>
        <b-col sm="3">
          <b-form-input v-model="totalGallons" readonly min="0" max="1000000" step=".10"
                        type="number"></b-form-input>
        </b-col>
      </b-row>

      <b-row style="margin-bottom: 10px ">
        <b-col sm="9">Equivalent total cases of wine</b-col>
        <b-col sm="3">
          <b-form-input readonly v-model="equivalentCases"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12"></b-col>
      </b-row>
    </b-container>
</template>

<script>
import Bus from "../eventBus";
import {roundColumnValue, roundNumberToTwoDecimalPlace} from "@/MetricUtils";


export default {
  name: "WineProduction",
  props: {year: Number}
  , data() {
    return {
      id: '',
      groupId: localStorage.getItem('adminImpersonationGroupId') !== null ? localStorage.getItem('adminImpersonationGroupId') : localStorage.getItem('groupId'),
      brandWineProduced: 0,
      customCrushWineProduced: 0,
      bulkWineShippedOffsite: 0,
      bulkWineIn: 0,
      wineStorageBarrels: 0,
      enteredValueDecimalPlaces: 2,
      totalsValueDecimalPlaces: 0,
      wineYear: this.year,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
        },
        mounted() {
            let self = this;
            this.$http.get("metrics/production/data/" + self.groupId)
                .then(result => {
                    if (result.data !== null) {
                        result.data.forEach(prodData => {
                            if (prodData.year === parseInt(self.wineYear)) {
                              self.id = prodData._id;
                              self.brandWineProduced = prodData.brandWine;
                              self.customCrushWineProduced = prodData.customCrushWine;
                              self.bulkWineShippedOffsite = prodData.bulkWine;
                              self.bulkWineIn = prodData.bulkWineIn;
                              self.wineStorageBarrels = prodData.wineStorageBarrels;
                            }
                        });
                    }
                }).catch(err => {
              console.log(err)
              this.nextTick(this.sendUpdate(this.wineYear))
            });
        },
        created() {
          console.log("WineryProduction");
            Bus.$on('page-update', this.messageReceived);
        },
        beforeDestroy() {
            Bus.$off('grid-edited', this.messageReceived);
            Bus.$off('page-update', this.messageReceived);
        },
        methods: {
          roundColumnValue: function (value) {
            let parsedValue = Number.parseFloat(value);
            return roundColumnValue(parsedValue, this.enteredValueDecimalPlaces);
          },
          messageReceived: function () {
            // Unimplemented
          },
          canEdit: function () {
            console.log(`Is Viewer: ${this.isViewer}`)
            return this.isViewer;
          },
          sendUpdate: function () {
            console.log(this.equivalentCases);
            console.log(this.totalGallons);
            Bus.$emit('wine-production', {type: "equivalentCase", total: this.equivalentCases, year: this.year});
          },
          productionChanged: function () {
            let self = this;
            self.brandWineProduced = roundNumberToTwoDecimalPlace(Number(self.brandWineProduced) || 0);
            self.customCrushWineProduced = roundNumberToTwoDecimalPlace(Number(self.customCrushWineProduced) || 0);
            self.bulkWineShippedOffsite = roundNumberToTwoDecimalPlace(Number(self.bulkWineShippedOffsite) || 0);
            self.bulkWineIn = roundNumberToTwoDecimalPlace(Number(self.bulkWineIn) || 0);
            self.wineStorageBarrels = roundNumberToTwoDecimalPlace(Number(self.wineStorageBarrels) || 0);

            let wineProduction = {
              _id: this.id,
              groupId: self.groupId,
              brandWine: self.brandWineProduced,
              customCrushWine: self.customCrushWineProduced,
              bulkWine: self.bulkWineShippedOffsite,
              year: self.wineYear,
              bulkWineIn: self.bulkWineIn,
              wineStorageBarrels: self.wineStorageBarrels
            }

            let wineProductionJson = JSON.stringify(wineProduction, null, 3);
            this.$http.post("metrics/production/data/" + self.groupId, wineProductionJson
                , {
                  headers: {
                    'content-type': 'application/json'
                  }
                }).then(response => {
              if (self.id === '') {
                self.id = response.data._id;
                    }
                });
            }
        },
        computed:
            {
              /*              "Crush to Bottle Brand Wine Produced on Site (Gal)" + "Crush to Bottle Custom Crush Produced on Site (Gal)" + .8* "Crush to Wine-Bottle off site (Gal)" +
                                .20 *"Bulk Wine In (Bottling only or Bulked Out) (Gal)" + .15 * "Wine storage only-barrels (Gal)"*/
              totalGallons: function () {
                let totalGallonsOfWine = parseInt(this.brandWineProduced, 10) + parseInt(this.customCrushWineProduced, 10)
                    + (.8 * parseInt(this.bulkWineShippedOffsite, 10)) + (.20 * parseInt(this.bulkWineIn, 10))
                    + (.15 * parseInt(this.wineStorageBarrels, 10));
                totalGallonsOfWine = Number(totalGallonsOfWine) || 0;
                Bus.$emit('wine-production', {type: "totalWine", total: totalGallonsOfWine, year: this.year});
                return roundColumnValue(totalGallonsOfWine, this.totalsValueDecimalPlaces);
              },
              equivalentCases: function () {
                let equivalentCases1 = (this.totalGallons / 2.378).toFixed(1);
                equivalentCases1 = Number(equivalentCases1) || 0;
                Bus.$emit('wine-production', {type: "equivalentCase", total: equivalentCases1, year: this.year});
                return roundColumnValue(equivalentCases1, this.totalsValueDecimalPlaces);
              }
            }
    }
</script>

<style scoped>

</style>
